import type { ExcelColumnMapping } from './types';
import { formatDate } from '@/lib/formatUtils';

export const BANG_TONG_HOP_HOA_DON_COLUMNS: ExcelColumnMapping[] = [
  { header: 'Đơn vị', width: 18, resolver: row => row.ma_unit ?? '' },
  { header: 'Ngày c/từ', width: 18, resolver: row => formatDate(row.ngay_ct) ?? '' },
  { header: 'Số c/từ', width: 18, resolver: row => row.so_ct ?? '' },
  { header: 'Số hóa đơn', width: 18, resolver: row => row.so_ct0 ?? '' },
  { header: 'Mã khách hàng', width: 18, resolver: row => row.ma_kh ?? '' },
  { header: 'Tên khách hàng', width: 18, resolver: row => row.ten_kh ?? '' },
  { header: 'Diễn giải', width: 18, resolver: row => row.dien_giai ?? '' },
  { header: 'Doanh thu', width: 18, resolver: row => Number(row.tien2 ?? 0) },
  { header: 'Thuế', width: 18, resolver: row => Number(row.thue ?? 0) },
  { header: 'Chiết khấu', width: 18, resolver: row => Number(row.ck ?? 0) },
  { header: 'Phải thu', width: 18, resolver: row => Number(row.pt ?? 0) },
  { header: 'Mã NVBH', width: 18, resolver: row => row.ma_nvbh ?? '' },
  { header: 'Tên nhân viên bán hàng', width: 18, resolver: row => row.ten_nvbh ?? '' },
  { header: 'Mã vụ việc', width: 18, resolver: row => row.ma_vv ?? '' },
  { header: 'Mã hợp đồng', width: 18, resolver: row => row.ma_hd ?? '' },
  { header: 'Mã chứng từ', width: 18, resolver: row => row.ma_ct ?? '' }
];
